import React from 'react';

import DropdownWrap from './DropdownWrap';
import styles from './Item.scss';

export const TEST_NAME_ITEM = 'ITEM';
export const TEST_NAME_DROPDOWN_WRAP = 'DROPDOWN_WRAP';
export const TEST_NAME_TEXT = 'TEXT';

interface ItemProps {
  id: string;
  optionsLength: number;
  selected: {
    id?: string;
    text?: string;
  };
  setAriaLiveMessage: (...args: unknown[]) => unknown;
  setItemRef: (...args: unknown[]) => unknown;
  text: string;
  updatePositions: (...args: unknown[]) => unknown;
  setAriaLiveMessageForLiveRegion: (...args: unknown[]) => unknown;
  defaultPosition: number;
}

export default function Item(props: ItemProps) {
  const {
    id,
    optionsLength,
    selected,
    setAriaLiveMessage,
    setItemRef,
    text,
    updatePositions,
    setAriaLiveMessageForLiveRegion,
    defaultPosition
  } = props;

  const callSetItemRef = (ref) => setItemRef(id, ref);

  return (
    <div key={id} ref={callSetItemRef} className={styles.item} data-test-name={TEST_NAME_ITEM}>
      <div
        data-test-name={TEST_NAME_TEXT}
        className={styles.text}
        dangerouslySetInnerHTML={{ __html: text }}
      />

      <span className={styles.dropdownWrapper} data-test-name={TEST_NAME_DROPDOWN_WRAP}>
        <DropdownWrap
          label={text}
          id={id}
          optionsLength={optionsLength}
          selected={selected}
          setAriaLiveMessage={setAriaLiveMessage}
          setAriaLiveMessageForLiveRegion={setAriaLiveMessageForLiveRegion}
          text={text}
          updatePositions={updatePositions}
          defaultPosition={defaultPosition}
        />
      </span>
    </div>
  );
}
